import { Alerts } from '..';
import api from '../../ApiConfig';
import { Apis } from '../../config';

const getAllOrders = async ({ search = '', page = 1, limit = 10, startDate, endDate, paymentStatus, orderStatus }) => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    if (search) params.append('search', search);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (paymentStatus) params.append('paymentStatus', paymentStatus);
    if (orderStatus) params.append('orderStatus', orderStatus);

    const token = localStorage.getItem('userToken');
    const result = await api.get(`${Apis.GetAllOrders}?${params.toString()}`, {
      headers: {
        'x-access-token': token
      }
    });

    if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    console.error('Error in getAllOrders:', error);
    return null;
  }
};
// const getAllOrders = async ({ search = '', page = 1, limit = 10 }) => {
//   try {
//       const params = new URLSearchParams({ page, limit });
//     if (search) params.append('search', search);

//     var token = localStorage.getItem('userToken');
//     let result = await api.get(`${Apis.GetAllOrders}?${params.toString()}`, {
//       headers: {
//         'x-access-token': token
//       }
//     });
//     if (result.data.error) {
//       return null;
//     }
//     return result.data;

//   } catch (error) {
//     return null;
//   }
// };
const getSingleOrders = async (id) => {
    try {
      var token = localStorage.getItem('userToken');
      let result = await api.get(Apis.GetSingleOrders+id, {
        headers: {
          'x-access-token': token
        }
      });
      if (result.data.error) {
        return null;
      }
      return result.data;
  
    } catch (error) {
      return null;
    }
  };

const getSingleOrderPayments = async (id) => {
    try {
      var token = localStorage.getItem('userToken');
      let result = await api.get(Apis.GetSingleOrderPayments+id, {
        headers: {
          'x-access-token': token
        }
      });
      if (result.data.error) {
        return null;
      }
      return result.data;
  
    } catch (error) {
      return null;
    }
  };
  
  const generateOrderInvoice = async (id) => {
    try {
      var token = localStorage.getItem('userToken');
      let result = await api.get(Apis.GenerateOrderInvoice+id, {
        headers: {
          'x-access-token': token
        }
      });

      if (result.data.error) {
        return null;
      }
      return result.data;
  
    } catch (error) {
      return null;
    }
  };

    const generateOrdersInvoices = async (orderIds) => {
    try {
      var token = localStorage.getItem('userToken');
      let result = await api.post(Apis.GenerateOrdersInvoice, orderIds,{
        headers: {
          'x-access-token': token
        }
      });

      if (result.data.error) {
        return null;
      }
      return result.data;
  
    } catch (error) {
      return error;
    }
  };

const updateOrderStatus = async (id, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.put(Apis.UpdateOrderStatus+id, data, {
      headers: {
        'x-access-token': token
      }
    });
    console.log(result);
    if (result.data.error) {

      return null;
    }
    return result.data;

  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    return null;
  }
}
const updatePaymentStatus = async (id, data) => {
    try {
      var token = localStorage.getItem('userToken');
      let result = await api.put(Apis.UpdatePaymentStatus+id, data, {
        headers: {
          'x-access-token': token
        }
      });
      if (result.data.error) {
        return null;
      }
      return result.data;
  
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return null;
    }
  }


const getRecentOrders = async () => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.get(Apis.RecentOrders, {
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return error;
  }
};


const updateOrderNote = async (orderId, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.put(Apis.UpdateOrderNote+orderId, data,{
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return error;
  }
};

const updateUserShippingAddress = async (userId, orderId, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(`${Apis.AddShippingAddress + userId}/${orderId}`, data,{
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return error;
  }
};
const updateUserBillingAddress = async (userId, orderId, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(`${Apis.AddBillingAddress + userId}/${orderId}`, data,{
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return error;
  }
};



const makeSameBillingShippingAddress = async (userId, orderId, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(`${Apis.MakeSameBillingShippingAddress + userId}/${orderId}`, data,{
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return error;
  }
};


const createCheckoutSession = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(`${Apis.CreateCheckoutSession}`, data,{
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return error;
  }
};

const resendCheckoutSession = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(`${Apis.ResendCheckoutSession}`, data,{
      headers: {
        'x-access-token': token
      }
    });
    if (result.data.error) {
      return null;
    }
    return result.data;

  } catch (error) {
    return error;
  }
};


const createAdminOrder = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(`${Apis.CreateAdminOrder}`, data,{
      headers: {
        'x-access-token': token
      }
    });
    // if (result.data.error) {
    //   return null;
    // }
    return result.data;

  } catch (error) {
    return error;
  }
};

const exportUsers = async (order_ids) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.get(`${Apis.ExportOrders}?order_ids=${order_ids}`,{
       responseType: 'blob',
      headers: {
        'x-access-token': token
      }
    });
     if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    return null;
  }
}


const addOrderNote = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(Apis.AddOrderNote, data,{
      headers: {
        'x-access-token': token
      }
    });
     if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    return null;
  }
}
const udpateOrderNote = async (orderId, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.put(Apis.UpdateOrderNote+orderId, data,{
      headers: {
        'x-access-token': token
      }
    });
     if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    return null;
  }
}

const deleteOrderNote = async (orderId) => {
  try {
    var token = localStorage.getItem('userToken');
    let result = await api.post(Apis.DeleteOrderNote, orderId,{
      headers: {
        'x-access-token': token
      }
    });

    console.log(result);
     if (result.data.error) {
      return null;
    }
    return result.data;
  } catch (error) {
    return null;
  }
}

const createOrderRefund = async (data) => {
  try {
    var token = localStorage.getItem('userToken');
    let response = await api.post(Apis.CreateOrderRefund, data,{
      headers: {
        'x-access-token': token
      }
    });
     return { success: true, data: response.data };
  } catch (error) {
      if (error.response) {
      return { 
        success: false, 
        status: error.response.status, 
        message: error.response.data.message || "Something went wrong" 
      };
    } else if (error.request) {
      return { success: false, message: "No response from server" };
    } else {
      return { success: false, message: error.message };
    }
  }
}

const processOrder = async (id, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let response = await api.put(Apis.ProcessOrder+id, data,{
      headers: {
        'x-access-token': token
      }
    });
     return { success: true, data: response.data };
  } catch (error) {
      if (error.response) {
      return { 
        success: false, 
        status: error.response.status, 
        message: error.response.data.message || "Something went wrong" 
      };
    } else if (error.request) {
      return { success: false, message: "No response from server" };
    } else {
      return { success: false, message: error.message };
    }
  }
}
const cancelOrder = async (id, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let response = await api.put(Apis.CancelOrder+id, data,{
      headers: {
        'x-access-token': token
      }
    });
     return { success: true, data: response.data };
  } catch (error) {
      if (error.response) {
      return { 
        success: false, 
        status: error.response.status, 
        message: error.response.data.message || "Something went wrong" 
      };
    } else if (error.request) {
      return { success: false, message: "No response from server" };
    } else {
      return { success: false, message: error.message };
    }
  }
}


const cancelOrderApproval = async (id, data) => {
  try {
    var token = localStorage.getItem('userToken');
    let response = await api.put(Apis.CancelOrderApproval+id, data,{
      headers: {
        'x-access-token': token
      }
    });
     return { success: true, data: response.data };
  } catch (error) {
      if (error.response) {
      return { 
        success: false, 
        status: error.response.status, 
        message: error.response.data.message || "Something went wrong" 
      };
    } else if (error.request) {
      return { success: false, message: "No response from server" };
    } else {
      return { success: false, message: error.message };
    }
  }
}

const exportedObject = {
    getAllOrders,
    getSingleOrders,
    updateOrderStatus,
    updatePaymentStatus,
    getRecentOrders,
    updateOrderNote,
    updateUserShippingAddress,
    makeSameBillingShippingAddress,
    updateUserBillingAddress,
    createCheckoutSession,
    createAdminOrder,
    resendCheckoutSession,
    generateOrderInvoice,
    generateOrdersInvoices,
    exportUsers,
    addOrderNote,
    udpateOrderNote,
    deleteOrderNote,
    createOrderRefund,
    getSingleOrderPayments,
    processOrder,
    cancelOrder,
    cancelOrderApproval
};
export default exportedObject;